import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import WhatsAppButton from '@/components/WhatsAppButton';
import ScrollToTop from '@/components/ScrollToTop';
import Home from '@/pages/Home';
import About from '@/pages/About';
import Services from '@/pages/Services';
import { AmazonServices, AmazonListingSEO, AmazonPPC, AmazonAPlus, AmazonBrandStore, FlipkartServices, FlipkartListingSEO, FlipkartAdvertising, MyntraServices, MyntraAccountManagement, BlinkitServices, BlinkitAccountManagement, QuickCommerceServices, AjioServices, AjioListing, SwiggyInstamartOnboarding, SwiggyInstamartAccountManagement, ZomatoOnboarding, ZomatoAccountManagement, SwiggyOnboarding, SwiggyAccountManagement, LocalSEO, WordPressServices, ShopifyServices } from '@/pages/services';
import { BlogList, BlogDetail } from '@/pages/Blog';
import { CaseStudiesList, CaseStudyDetail } from '@/pages/CaseStudies';
import Contact from '@/pages/Contact';
import Admin from '@/pages/Admin';
import InventoryWarehouseTool from '@/pages/InventoryWarehouseTool';
import AmazonRevenueCalculator from '@/pages/AmazonRevenueCalculator';

// Note: Each page now manages its own canonical URL via React Helmet
// The global SEOHead was removed to prevent homepage canonical from overriding page-specific canonicals

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
        <Toaster position="top-right" richColors />
        <Routes>
          <Route
            path="/admin/*"
            element={
              <>
                <Header />
                <Admin />
              </>
            }
          />
          <Route
            path="/*"
            element={
              <>
                <Header />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/amazon-account-management-services" element={<AmazonServices />} />
                  <Route path="/amazon-listing-seo-optimization" element={<AmazonListingSEO />} />
                  <Route path="/amazon-ppc-advertising-services" element={<AmazonPPC />} />
                  <Route path="/amazon-aplus-content-design" element={<AmazonAPlus />} />
                  <Route path="/amazon-brand-store-setup" element={<AmazonBrandStore />} />
                  <Route path="/flipkart-account-management-services" element={<FlipkartServices />} />
                  <Route path="/flipkart-listing-seo-optimization" element={<FlipkartListingSEO />} />
                  <Route path="/flipkart-advertising-management" element={<FlipkartAdvertising />} />
                  <Route path="/myntra-listing-catalog-optimization" element={<MyntraServices />} />
                  <Route path="/myntra-account-management-services" element={<MyntraAccountManagement />} />
                  <Route path="/ajio-account-management-services" element={<AjioServices />} />
                  <Route path="/ajio-product-listing-catalog" element={<AjioListing />} />
                  <Route path="/quick-commerce-account-management" element={<QuickCommerceServices />} />
                  <Route path="/blinkit-seller-onboarding" element={<BlinkitServices />} />
                  <Route path="/blinkit-account-management" element={<BlinkitAccountManagement />} />
                  <Route path="/swiggy-instamart-seller-onboarding" element={<SwiggyInstamartOnboarding />} />
                  <Route path="/swiggy-instamart-account-management" element={<SwiggyInstamartAccountManagement />} />
                  <Route path="/zomato-seller-onboarding" element={<ZomatoOnboarding />} />
                  <Route path="/zomato-account-management" element={<ZomatoAccountManagement />} />
                  <Route path="/swiggy-seller-onboarding" element={<SwiggyOnboarding />} />
                  <Route path="/swiggy-account-management" element={<SwiggyAccountManagement />} />
                  <Route path="/google-business-profile-optimization" element={<LocalSEO />} />
                  <Route path="/wordpress-website-development" element={<WordPressServices />} />
                  <Route path="/shopify-store-development" element={<ShopifyServices />} />
                  <Route path="/blog" element={<BlogList />} />
                  <Route path="/blog/:slug" element={<BlogDetail />} />
                  <Route path="/case-studies" element={<CaseStudiesList />} />
                  <Route path="/case-studies/:slug" element={<CaseStudyDetail />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/tools/inventory-warehouse" element={<InventoryWarehouseTool />} />
                  <Route path="/tools/amazon-revenue-calculator" element={<AmazonRevenueCalculator />} />
                </Routes>
                <Footer />
                <WhatsAppButton />
              </>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
